import { FC } from 'react'
import { Helmet } from 'react-helmet-async'

const LabPage: FC = () => {
  return (
    <>
      <Helmet>
        <title>RAMO - Lab</title>
      </Helmet>

      <iframe src={import.meta.env.VITE_APP_LAB_URL} className="h-full w-full border-0" title="Lab" allow="fullscreen" />
    </>
  )
}

export default LabPage
